<template>
  <transition>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="page-title-box">
            <div class="page-title-right float-left">
              <h4 style="margin: 0; padding: 8px 0 1.5rem 0">Product Type List</h4>
            </div>
            <div class="page-title-right float-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item active">Product Type</li>
                <li class="breadcrumb-item">
                  <a href="javascript: void(0);">Product Type List</a>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <Modal @close="toggleModal()" :modalActive="modalActive">
        <div class="modal-content scrollbar-width-thin">
          <div class="modal-header">
            <h4>Product Type Manage</h4>
            <button @click="toggleModal()" type="button" class="btn btn-default">
              X
            </button>
          </div>
          <form @submit.prevent="submitForm()" enctype="multipart/form-data">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name"> Name *</label>
                    <input
                      type="text"
                      class="form-control border"
                      @keypress="onkeyPress('name')"
                      v-model="form.name"
                      id="name"
                      placeholder=" Name"
                      autocomplete="off"
                    />
                    <div class="invalid-feedback" v-if="errors.name">
                      {{ errors.name[0] }}
                    </div>
                  </div> 
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name"> Status *</label>
                    <select class="form-select" v-model="form.status">
                      <option value="1">Active</option>
                      <option value="0">In-Active</option>
                    </select> 
                  </div> 
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary" :disabled="disabled">
                <span v-show="isSubmit">
                  <svg v-show="isSubmit" class="spinner" width="20px" height="20px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                                     </svg> &nbsp;</span
                >{{ btn }}
              </button>
            </div>
          </form>
        </div>
      </Modal>

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <button
                type="button"
                class="btn btn-primary float-right"
                @click="toggleModal()"
              >
                <i class="mdi mdi-plus-outline"></i> Add New
              </button>
            </div>
            <div class="card-body table-responsive">
              <table
                class="table table-centered table-bordered table-nowrap w-100"
                v-if="!loading"
              >
                <thead class="table-light">
                  <tr class="border success item-head">
                    <th width="5%" class="text-center">SL</th>
                    <th width="40%">Name</th> 
                    <th width="20%" class="text-center">Status</th> 
                    <th width="10%" class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody v-if="items.length > 0">
                  <tr class="border" v-for="(item, i) in items" :key="i">
                    <td class="text-center">{{ i + 1 }}</td>
                    <td>{{ item.name }}</td> 
                    <td class="text-center">
                      <span v-if="item.status ==1" class="badge bg-success">Active</span>
                      <span v-else class="badge bg-warning">In-Active</span>
                    </td> 
                    <td class="text-center">
                      <div class="dropdown float-end">
                        <a
                          href="#"
                          class="dropdown-toggle arrow-none card-drop"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i class="mdi mdi-dots-vertical"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end"> 
                          <a
                            href="javascript:void(0);"
                            class="dropdown-item text-warning"
                            @click="edit(item)"
                          >
                            <i class="mdi mdi-circle-edit-outline me-1"></i>Edit</a
                          >
                          <a
                            href="javascript:void(0);"
                            class="dropdown-item text-danger"
                            @click="deleteItem(item)"
                            ><i class="mdi mdi-delete-outline me-1"></i>Delete</a
                          >
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="tab-pane show active" v-if="loading">
                <div class="row">
                  <div class="col-md-5"></div>
                  <div class="col-md-2">
                    <img
                      src="../../assets/image/loading.gif"
                      alt="Loading..."
                      style="width: 130px"
                    />
                  </div>
                  <div class="col-md-5"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "./../helper/Modal.vue";
import { ref, onMounted, getCurrentInstance } from "vue";
import Form from "vform";
import axios from "axios"; 
export default {
  name: "PosLeftbar",
  components: {
    Modal, 
  },
  data() {
    return {
      loading: true,
      isSubmit: false,
      showModal: false,
      editMode: false,
      disabled: false,
      modalActive: false,
      errors: {},
      btn: "Create",
      items: [],
      form: new Form({
        id: "",
        name: "", 
        status: 1,
      }),
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    toggleModal: function () {
      this.modalActive = !this.modalActive;
      if (!this.modalActive) {
        this.editMode = false;
        this.btn = "Create";
      }
      this.errors = "";
      this.isSubmit = false;
      this.form.reset();
    },
    fetchData() {
      axios
        .get(this.apiUrl + "/product_types", this.headerjson)
        .then((res) => {
          this.items = res.data.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message);
        })
        .finally((fres) => {
          this.loading = false;
        });
    },

    edit: function (item) {
      this.btn = "Update";
      this.editMode = true;
      this.toggleModal();
      this.form.fill(item);
    },
    submitForm: function (e) { 
      this.isSubmit = true;
      this.disabled = true;
      const formData = new FormData();
      formData.append("name", this.form.name); 
      formData.append("status", this.form.status); 
      if (this.editMode) { 
        formData.append('_method', 'put');
        var postEvent = axios.post(this.apiUrl + "/product_types/" + this.form.id, formData, this.headers);
      } else {
        var postEvent = axios.post(this.apiUrl + "/product_types", formData, this.headers);
      }

      postEvent
        .then((res) => {
          this.isSubmit = false;
          this.disabled = false;
          if (res.status == 200) {
            this.toggleModal();
            this.fetchData();
            this.$toast.success(res.data.message);
          } else {
            this.$toast.error(res.data.message);
          }
        })
        .catch((err) => {
          this.isSubmit = false;
          this.disabled = false;
          this.$toast.error(err.response.data.message);
          if (err.response.status == 422) {
            this.errors = err.response.data.errors;
          }
        });
    },

    onkeyPress: function (field) {
      for (var k in this.errors) {
        // Loop through the object
        if (k == field) {
          // If the current key contains the string we're looking for
          delete this.errors[k]; // Delete obj[key];
        }
      }
    },
    deleteItem: function (item) {
      this.$swal({
        title: "Are you sure?",
        text: "You want delete this item!",
        showCancelButton: true,
        confirmButtonCategory: "#3085d6",
        cancelButtonCategory: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          axios
            .delete(this.apiUrl + "/product_types/" + item.id, this.headers)
            .then((res) => {
              if (res.status == 200) {
                this.fetchData();
                this.$toast.success(res.data.message);
              } else {
                this.$toast.error(res.data.message);
              }
            })
            .catch((err) => {
              this.$toast.error(err.response.data.message);
              if (err.response.status == 422) {
                this.errors = err.response.data.errors;
              }
            });
        }
      });
    }, 
  },
  destroyed() {},
  mounted() {
    window.scrollTo(0, 0);
  },
  computed: {},
};
</script>

<style scoped>
.modal-content.scrollbar-width-thin {
  border: none !important;
  width: 600px;
}

label {
  display: inline-block;
  margin: 0px 0px 4px 2px;
  float: left;
}
 

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  text-align: left;
}
</style>
